module.exports = __webpack_public_path__ + "img/PersonalDetails.bedf4e20.svg";